import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";

import axios from "axios";

import {
  PanelHeader, 
  Button,
  Timeline,
  Stats
} from "components";

import { thead, tbody } from "variables/general";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";

// react plugin used to create DropdownMenu for selecting items
import Select from "react-select";
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import moment from "moment";

const NOTA = "nota";
const noteType = [
  { value: "59", label: "General" },
  { value: "60", label: "Incidencia" },
  { value: "62", label: "Log" },
  { value: "61", label: "Solución" },
  { value: "214", label: "Devolución" }
  /*,
  { value: "three", label: "Baja" },
  { value: "four", label: "Suspensión por impago" },
  { value: "five", label: "Cambio de nombre" },
  { value: "six", label: "Cambio de tarifa" }*/
];

const formatterCurrency = new Intl.NumberFormat("de-DE", {
  style: 'currency',
  currency: 'EUR'
});


class CashRegisterDetail extends React.Component {
  constructor(props) {
    super(props);
    if (!props.userData.isBillingDepartmentN1()) this.redirectTo("/dashboard");
    let cashRegisterID = this.props.match.params.cashRegisterId;
    this.state = {
      cashRegister: this.getCurrentCashRegister(cashRegisterID, this.props.mainState.cashRegisters),
      newRegistry: {}
    };
    /* ////console.log(props); */
    this.createRightColumn = this.createRightColumn.bind(this);
    this.getNotes = this.getNotes.bind(this);
    this.showPopUp = this.showPopUp.bind(this);
    this.createPopUp = this.createPopUp.bind(this);
    this.showPopUpConfirmation = this.showPopUpConfirmation.bind(this);
    this.hidePopUpConfirmation = this.hidePopUpConfirmation.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.newNoteConfirmation = this.newNoteConfirmation.bind(this);
    this.validateNewNote = this.validateNewNote.bind(this);
    this.createRegistry = this.createRegistry.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.validateRegistry = this.validateRegistry.bind(this);
  }
  getCurrentCashRegister(cashRegisterID, cashRegistersList) {
    let result = null;
    if (cashRegistersList) {
      cashRegistersList.map(current => {
        if (parseInt(current.id) === parseInt(cashRegisterID)) result = current;
      });
  
      // console.log("Caja encontrada");
      // console.log(result);
    }

    return result;
  }
  getNotes(order_id) {
    this.props.getCustomerNotes(order_id);
  }
  componentDidUpdate(prevProps, prevState) {
    // console.log("ESTADO ACTUAL DETALLE CAJA");
    // console.log(this.state);
    if (this.state.cashRegister) {
      let cashRegisterID = this.props.match.params.cashRegisterId;
      let newCashRegister = this.getCurrentCashRegister(cashRegisterID, this.props.mainState.cashRegisters);
      let currentCashRegistry = this.state.cashRegister;
      if (newCashRegister.amount !== currentCashRegistry.amount || newCashRegister.registries.length !== currentCashRegistry.registries.length) {
        this.setState({
          cashRegister: newCashRegister
        });
      }
    }
    if (!this.props.mainState.creatingCashRegistry && prevProps.mainState.creatingCashRegistry) {
      this.setState({
        newRegistry: {}
      });
    }
  }
  componentDidMount() {
  }
  handleChange(field, event) {
    ////////console.log("Field name: " + field);
    ////////console.log("Field value: " + event.target.value);
    let newRegistry = this.state.newRegistry;
    newRegistry[field] = event.target.value;
    this.setState({ newRegistry: newRegistry });
  }
  showPopUp(tipo) {
    // console.log("######### OPCIONES ###########");
    // console.log(this.props.mainState);
    this.setState({
      popUpToShow: tipo,
      showPopUp: true,
      noteText: "",
      noteTitle: "",
      noteType: ""
    });
  }
  createPopUp() {
    // console.log("############# CREATING POPUP #############");
    // console.log(this.state);
    // console.log(this.props.mainState);
    switch (this.state.popUpToShow) {
      case NOTA:
        return this.createNotePopUp();
      default:
        //console.log("################## ERROR CREATE POPUP ################");
        //console.log("POPUP TO SHOW NOT SPECIFIED");
        return;
    }
  }
  createNotePopUp() {
    return (
      <SweetAlert
        style={{ display: "block", marginTop: "-250px" }}
        title="Escribir nota"
        onConfirm={() => this.showPopUpConfirmation(NOTA)}
        onCancel={() => this.hideAlert()}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="default"
        confirmBtnText="Guardar"
        cancelBtnText="Cancelar"
        showCancel
      >
        <Form className="form-horizontal">
          <Row>
            <Label md={3}>Tipo</Label>
            <Col xs={12} md={9}>
              <FormGroup>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  placeholder="Tipo de nota"
                  name="noteType"
                  value={this.state.noteType}
                  options={noteType}
                  onChange={value => this.setState({ noteType: value })}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Label md={3}>Título</Label>
            <Col xs={12} md={9}>
              <FormGroup>
                <Input
                  type="text"
                  name="noteTitle"
                  placeholder="Título de la nota"
                  value={this.state.noteTitle}
                  onChange={event => this.setState({ noteTitle: event.target.value })}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col size={12}>
              <FormGroup>
                <CKEditor
                  editor={ ClassicEditor }
                  config={{
                    toolbar: [
                      'heading', '|',
                      'bold', 'italic','|',
                      'link', '|',
                      'outdent', 'indent', '|',
                      'bulletedList', 'numberedList', '|',
                      'insertTable', '|',
                      'blockQuote', '|',
                      'undo', 'redo'
                    ]
                  }}
                  data={this.state.noteText}
                  onInit={ editor => {
                  } }
                  onChange={ ( event, editor ) => {
                      const data = editor.getData();
                      this.setState({ noteText: data });
                  } }
                />
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </SweetAlert>
    );
  }
  showPopUpConfirmation(tipo) {
    switch (tipo) {
      case NOTA:
        this.newNoteConfirmation();
        break;
      default:;
    }
  }
  newNoteConfirmation() {
    if (!this.validateNewNote()) {
      return;
    }
    //console.log("################## SHOW POP UP CONFIRMATION ################");
    //console.log(this.state);
    this.props.createNote(
      this.state.noteType.value,
      this.state.noteTitle,
      this.state.noteText,
      this.state.currentBillID
    );
    this.setState({
      showPopUp: false,
      popUpConfirmation: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-250px" }}
          title="¡Añadida!"
          onConfirm={() => this.hidePopUpConfirmation()}
          onCancel={() => this.hidePopUpConfirmation()}
          confirmBtnBsStyle="default"
          confirmBtnText="Cerrar"
        >
          La nota ha sido añadida.
        </SweetAlert>
      )
    });
  }
  hidePopUpConfirmation() {
    this.setState({
      popUpConfirmation: null
    });
  }
  validateNewNote() {
    let validation = true;
    if (this.state.noteText === "") validation = false;
    return validation;
  }
  hideAlert() {
    this.setState({
      showPopUp: false
    });
  }
  createRightColumn() {
    let rightColumn = [];
    rightColumn.push(<br />);
    // if (!(this.props.mainState.user.field_tipo_distribuidor.und && 
    //       this.props.mainState.user.field_tipo_distribuidor.und[0].tid === 180)) {
    //   rightColumn.push(
    //     <Card size={12} key="buttonsCard">
    //       <CardBody>{this.createActionButtons()}</CardBody>
    //     </Card>
    //   );
    // }

    let notesCardHeader = (
        <CardHeader className="txt-black">
          <h5>
            <i className="now-ui-icons design-2_ruler-pencil" /> Notas{"  "}
            <Button
              icon
              round
              key={"createNoteButton"}
              color="info"
              onClick={() => {
                this.showPopUp(NOTA);
              }}
              leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
            />
          </h5>
        </CardHeader>
    );

    let notesCard = null;
    let notesCardBody = null;
    if (parseInt(this.state.currentBillID) in this.props.mainState.customerNotes) {
      let customerNotes = this.props.mainState.customerNotes[this.state.currentBillID];
      if (!customerNotes) customerNotes = [];
      if (customerNotes.length > 0) {
        customerNotes = customerNotes.map((note, key) => {
          let badgeStyle = 
          {
            color: "default",
            icon: "travel_info"
          };
          if (note.tipo === "Incidencia") {
            badgeStyle.color = "danger";
            badgeStyle.icon = "ui-2_settings-90";
          }
          if (note.tipo === "Solución") {
            badgeStyle.color = "primary";
            badgeStyle.icon = "ui-2_like";
          }
          if (note.tipo === "Log") {
            badgeStyle.color = "warning";
            badgeStyle.icon = "ui-1_bell-53";
          }
          if (note.tipo === "Pago") {
            badgeStyle.color = "primary";
            badgeStyle.icon = "business_money-coins";
          }

          return {
            inverted: true,
            badgeColor: badgeStyle.color,
            badgeIcon: "now-ui-icons " + badgeStyle.icon,
            title: note.autor + (note.titulo !== "" ? ": " + note.titulo : ""),
            titleColor: "danger",
            body: <div dangerouslySetInnerHTML={{ __html: note.texto }} />,
            footerTitle: <div dangerouslySetInnerHTML={{ __html: note.fecha }} />
          };
        });
        notesCardBody =
          <CardBody>
            <Timeline stories={customerNotes} simple />
          </CardBody>;
      } else {
        notesCardBody = 
          <CardBody>
            <div>
              <i className="now-ui-icons ui-1_simple-remove" /> No hay notas
            </div>
          </CardBody>;
      }
    } else if(parseInt(this.state.currentBillID) in this.props.mainState.isSearchingCustomerNotes || !this.state.currentBillID) {
      if (this.props.mainState.isSearchingCustomerNotes[parseInt(this.state.currentBillID)]) {
        notesCardBody = 
          <CardBody>
            <div>
              <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando...
            </div>
          </CardBody>;
      }
    }
    notesCard = (
      <Card key="notesCard" className="card-plain card-timeline">
        {notesCardHeader}
        {notesCardBody}
      </Card>
    );
    rightColumn.push(notesCard);

    if (rightColumn.length > 0) {
      return (
        <Col md={4} xs={12}>
          {rightColumn}
        </Col>
      );
    } else {
      return null;
    }
  }
  createRegistry() {
    if (!this.validateRegistry()) return;
    let newRegistry = this.state.newRegistry;
    newRegistry = {
      title: newRegistry.title,
      amount: newRegistry.amount,
      cash_register: this.state.cashRegister.id
    };
    this.props.createCashRegistry(newRegistry);
  }
  validateRegistry() {
    let result = true;
    if (!this.state.newRegistry.title || this.state.newRegistry.title.length === 0) result = false;
    if (!this.state.newRegistry.amount || this.state.newRegistry.amount.length === 0) result = false;

    return result;
  }
  buildTitle(title, amount) {
    let result = "";
    let registrySign = null;

    if (amount > 0) {
      registrySign = <span style={{padding: "5px 13px", background: "#46B98A", color: "#FFF", borderRadius: "3px", marginRight: "10px"}}>Ingreso</span>
    } else if (amount < 0) {
      registrySign = <span style={{padding: "5px 10px", background: "#ff5252", color: "#FFF", borderRadius: "3px", marginRight: "10px"}}>Retirada</span>
    } else {
      registrySign = <span style={{padding: "5px 15px", background: "#888888", color: "#000", borderRadius: "3px", marginRight: "10px"}}>Neutro</span>
    }

    result = 
      <span>
        {registrySign}{" "}{title}
      </span>;
    
    return result;
  }
  buildAmount(amount) {
    let result = "";
    let registrySign = null;

    if (amount > 0) {
      registrySign = {
        fontWeight: "bold",
        color: "#46B98A"
      };
    } else if (amount < 0) {
      registrySign = {
        fontWeight: "bold",
        color: "#ff5252"
      };
    } else {
      registrySign = {
        fontWeight: "bold",
        color: "#888888"
      };
    }

    result = 
      <span style={registrySign}>
        {formatterCurrency.format(parseInt(amount) / 100)}
      </span>;
    
    return result;
  }
  timestampToDate(timestamp) {
    return moment(timestamp * 1000).format("D/MM/YYYY - HH:mm");
  }
  render() {
    let contentToDisplay = null;
    if (this.state.cashRegister.registries && this.state.cashRegister.registries.length > 0){
      let registries = this.state.cashRegister.registries;
      contentToDisplay = 
        <Col xs={12}>
          <Card>
            <CardHeader>
              <CardTitle tag="h4">Movimientos</CardTitle>
            </CardHeader>
            <CardBody>
              <Table responsive>
                <thead>
                  <tr className="text-primary">
                    <th className="text-left">Fecha</th>
                    <th className="text-left">Concepto</th>
                    <th className="text-center">Autor</th>
                    <th className="text-center">Importe</th>
                  </tr>
                </thead>
                <tbody>
                  {registries.map((registry, key) => {
                    return (
                      <tr key={key}>
                        <td className="text-left">{this.timestampToDate(registry.date)}</td>
                        <td className="text-left">{this.buildTitle(registry.title, parseInt(registry.amount))}</td>
                        <td className="text-center">{registry.author.name}</td>
                        <td className="text-center">{this.buildAmount(parseInt(registry.amount))}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>;
    } else {
      contentToDisplay = 
        <Col xs={12}>
          <Card>
            <CardHeader>
              <CardTitle tag="h4">Movimientos</CardTitle>
            </CardHeader>
            <CardBody>
              <div className="text-center">
                <i className="now-ui-icons arrows-1_refresh-69 spin" /> No hay registros en la caja...
              </div>
              <br />
            </CardBody>
          </Card>
        </Col>;
    }

    // let rightColumn = this.createRightColumn();
    return (
      <div>
        <PanelHeader
          content={
            <div className="header text-center">
              <span className="category">Importe disponible</span><br />
              <h2 className="title">{formatterCurrency.format(parseInt(this.state.cashRegister.amount)/100)}</h2>
              <div className="category">
                <Stats>
                  {[{ i: "now-ui-icons business_money-coins", t: this.state.cashRegister.name }]}
                </Stats>
                <Stats>
                  {[{ i: "now-ui-icons location_pin", t: this.state.cashRegister.office.name }]}
                </Stats>
              </div>
            </div>
          }
        />
        <div className="content">
          {this.state.showPopUp && this.createPopUp()}
          {this.state.popUpConfirmation}
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody className="form-inline">
                  <Input type="text" 
                    placeholder="Concepto"
                    value={this.state.newRegistry.title || ""}
                    onChange={(e) => this.handleChange("title", e)}
                    onKeyDown={e => {
                      //console.log(e.keyCode);
                      if(e.keyCode == 13){
                        //Enter is key code 13
                        this.createRegistry();
                        // put the login here
                      }
                    }}
                    style={{marginRight:"10px"}}
                  />
                  <Input type="number" 
                    placeholder="Importe"
                    value={this.state.newRegistry.amount || ""}
                    onChange={(e) => this.handleChange("amount", e)}
                    onKeyDown={e => {
                      //console.log(e.keyCode);
                      if(e.keyCode == 13){
                        //Enter is key code 13
                        this.createRegistry();
                        // put the login here
                      }
                    }}
                    style={{marginRight:"10px"}}
                  />
                  <Button
                    color={
                      this.props.mainState.creatingCashRegistry
                        ? "default"
                        : "primary"
                    }
                    round 
                    // icon 
                    disabled={this.props.mainState.creatingCashRegistry || !this.validateRegistry()}
                    onClick={this.createRegistry}>
                <i className={this.props.mainState.creatingCashRegistry?
                                      "now-ui-icons arrows-1_refresh-69 spin reposition-spin" :"now-ui-icons ui-1_simple-add"} />
                {" "} Crear registro
              </Button>
                </CardBody>
              </Card>
            </Col>
            <Col xs={12}>
              {contentToDisplay}
            </Col>
            {/* {rightColumn} */}
          </Row>
        </div>
      </div>
    );
  }
}

export default CashRegisterDetail;



// WEBPACK FOOTER //
// ./src/views/CashRegisters/CashRegisterDetail.jsx